import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class NFSeService {
  constructor(
    private http: HttpClient
  ) { }

  obterNotasFiscaisPorContaId(contaId, dataInicio, dataFim) {
    return this.http
      .get(urls.apiBase + '/NFSe/ObterNotasFiscaisPorContaId?contaId=' + contaId + '&dataInicio=' + dataInicio + '&dataFim=' + dataFim);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/nfse/nfse.service.ts